//Socios
const Choices = require('./choices.js');
const fecha = new Date();
const ultimo_dia_mes = [31,28,31,30,31,30,31,31,30,31,30,31];

function renderUsuariosSelect(todosUsuarios, assignedUsers, userFallback) {
    $("#usuarios").empty();
    if (!todosUsuarios || todosUsuarios.length === 0) return;

    var choicesUsuarios = Array();
    var valorSelectUsuarios = Array();
    $("#usuarios").append("<label>Usuario/s asignado/s</label><select multiple class='campo form-control' name='usuarios[]' value='' id='usuarios-list' style='text-align:center'></select>");

    var assignedUserIds = [];
    if (assignedUsers && assignedUsers.length > 0) {
        $.each(assignedUsers, function(i, u) {
            assignedUserIds.push(u['id']);
        });
    }
    if (assignedUserIds.length === 0 && userFallback && userFallback['id']) {
        assignedUserIds.push(userFallback['id']);
    }

    $.each(todosUsuarios, function(index, u) {
        var isSelected = assignedUserIds.includes(u['id']);
        if (isSelected) {
            valorSelectUsuarios.push(u['id']);
        }
        choicesUsuarios.push({
            value: u['id'],
            label: u['name'] + (u['email'] ? ' (' + u['email'] + ')' : ''),
            selected: isSelected,
        });
    });

    var selectUsuarios = new Choices('#usuarios-list', {
        choices: choicesUsuarios,
        removeItemButton: true,
        maxItemCount: -1,
        searchResultLimit: -1,
        renderChoiceLimit: -1,
        allowHTML: false,
        searchEnabled: true,
        searchChoices: true,
        searchFloor: 1,
        searchFields: ['label', 'value'],
        noResultsText: 'Sin resultados',
        noChoicesText: 'Sin resultados',
        placeholderValue: 'Seleccionar usuario/s...',
        itemSelectText: "",
    });
    $("#usuarios").val(valorSelectUsuarios);
}

$(document).on('click','.abreSocioModal', function(){
    $("#fichaSocio").modal("show");
    var id = this.id.substr(6,25);
    var checksActividades = "";
    $("#_method").val("PUT");
    $("#formSocio").attr('action',"socios/"+id);
    $(".btnDeleteSocio").css("display","block");
    $(".btnDeleteSocio").attr('id',"delete-"+id);
    $("#avatar").attr('src',"storage/avatar/noavatar.jpg");
    $("#actividades").empty();
    $("#usuarios").empty();
    $("#formSocio .is-invalid").removeClass("is-invalid");
    $("#formSocio .invalid-feedback").remove();
    $(".campo").val("");
    $(".campoSocio").val("");
    $.ajax({
        url: "socios/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#fichaSocioLabel").html("Edición de socio "+data['nombre']+" "+data['apellidos']);
            $.each(data,function(index,value){
                if(index == 'avatar'){
                    $("#contenedor-avatar").empty();
                    if(value === null){
                        $("#contenedor-avatar").append("<img src='storage/avatar/noavatar.jpg' class='d-block' width='300px'>");
                    }else{
                        $("#contenedor-avatar").append("<img id='image-"+data['id']+"' src='storage"+value+"' class='d-block' width='300px'><button  class='borraImagen' id='imgdel-"+data['id']+"' type='button'><i class='bi bi-trash3'></i></button>");
                    }
                   $("#contenedor-avatar").append("<input type='file' accept='.jpg,.png,.jpeg' class='campo form-control' name='avatar_file' id='avatar_file' style='text-align:center'>"); 
                }
                if(index == "actividades" && value!= null){
                    var choicesMulti = Array();
                    var valorselect = Array();
                    $("#actividades").append("<label>Actividad/es</label><select multiple class='campo form-control' name='actividades[]' value='' id='actividades-list' style='text-align:center'></select>");
                    $.each(value,function(index2,value2){
                        var selected = false;
                        if(value2['activa']){
                            $.each(data['assigned_actividades'],function(index3,value3){
                                valorselect.push(value3['id']);
                                if(value2['id'] == value3['id']){
                                    selected = true;
                                }
                            });
                            choicesMulti.push({
                                value:value2['id'],
                                label:value2['nombre'],
                                selected:selected,
                            });
                        }
                    });
                    var selectClases = new Choices('#actividades-list', {
                        choices: choicesMulti,
                        removeItemButton: true,
                        maxItemCount: -1,
                        searchResultLimit: -1,
                        renderChoiceLimit: -1,
                        allowHTML: false,
                        searchEnabled: true,
                        searchChoices: true,
                        searchFloor: 1,
                        searchFields: ['label', 'value'],
                        noResultsText: 'Sin resultados',
                        noChoicesText: 'Sin resultados',
                        placeholderValue: 'Selecciona...',
                        itemSelectText: "",
                    }); 
                    $("#actividades").val(valorselect);
                }
                if(index == "tipo_documento"){
                    $("#tipo_documento").val(value).change();
                }else{
                    $("#"+index.toLowerCase()).val(value);
                }
            });
            renderUsuariosSelect(data['todos_usuarios'], data['users'], data['user']);
            if(data['observaciones'] != null && data['obsevaciones'] != ""){
                Swal.fire({
                    title: "Observaciones",
                    text: data['observaciones'],
                    icon: "info"
                });  
            }
        }
    }); 
});
$(document).on('click','.nuevoSocioModal', function(){
    $("#_method").val("POST");
    $("#formSocio").attr('action',"socios");
    $("#fichaSocioLabel").html("Creación de nuevo socio");
    $("#avatar").attr('src',"storage/avatar/noavatar.jpg");
    $(".btnDeleteSocio").css("display","none");
    $("#btnReciboSocio").css("display","none");
    $("#btnHistorialReciboSocio").css("display","none");
    $("#actividades").empty();
    $("#usuarios").empty();
    if ($("#formSocio").length && $("#formSocio")[0].reset) {
        $("#formSocio")[0].reset();
    }
    $("#formSocio .is-invalid").removeClass("is-invalid");
    $("#formSocio .invalid-feedback").remove();
    $(".campo").val("");
    $(".campoSocio").val("");
    $("#contenedor-avatar").empty();
    $("#contenedor-avatar").append("<img src='storage/avatar/noavatar.jpg' class='d-block' width='300px'><div class='mb-3'></div>");
    $("#contenedor-avatar").append("<input type='file' accept='.jpg,.png,.jpeg' class='campo form-control' name='avatar_file' id='avatar_file' style='text-align:center'>"); 

    $.ajax({
        url: "actividades/aux",
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#actividades").append("<label>Actividad/es</label><select multiple class='campo form-control' name='actividades[]' value='' id='actividades-list' style='text-align:center'></select>");
            var choicesMulti = Array();
            $.each(data,function(index,value){
                var selected = false;
                if(value['activa']){
                    choicesMulti.push({
                        value:value['id'],
                        label:value['nombre'],
                        selected:selected,
                    });
                }
            });
            var selectClases = new Choices('#actividades-list', {
                choices: choicesMulti,
                removeItemButton: true,
                maxItemCount: -1,
                searchResultLimit: -1,
                renderChoiceLimit: -1,
                allowHTML: false,
                searchEnabled: true,
                searchChoices: true,
                searchFloor: 1,
                searchFields: ['label', 'value'],
                noResultsText: 'Sin resultados',
                noChoicesText: 'Sin resultados',
                placeholderValue: 'Selecciona...',
                itemSelectText: "",
            }); 
        }
    });

    $.ajax({
        url: "usuarios/aux",
        type: "GET",
        dataType: "json",
        success: function(data){
            renderUsuariosSelect(data, [], null);
        }
    });
});

$(document).on("submit", "#formSocio", function (e) {
    e.preventDefault();

    var form = this;
    var $form = $(form);
    var rawUrl = $form.attr("action") || "socios";
    var url = "/" + rawUrl.replace(/^\/+/, "");
    var formData = new FormData(form);
    var $submitBtn = $form.find('button[type="submit"]');

    // Limpiar estados de error previos
    $form.find(".is-invalid").removeClass("is-invalid");
    $form.find(".invalid-feedback").remove();

    $submitBtn.prop("disabled", true);

    $.ajax({
        url: url,
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Accept": "application/json"
        },
        success: function (response) {
            $submitBtn.prop("disabled", false);
            $("#fichaSocio").modal("hide");
            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: response.message || "Socio guardado con éxito.",
                timer: 1500,
                showConfirmButton: false
            });
            setTimeout(function () {
                location.reload();
            }, 1000);
        },
        error: function (xhr) {
            $submitBtn.prop("disabled", false);

            if (typeof Swal !== "undefined" && Swal.close) {
                Swal.close();
                setTimeout(function () {
                    if (typeof Swal !== "undefined" && Swal.isVisible && Swal.isVisible()) {
                        Swal.close();
                    }
                }, 100);
            }

            if (xhr.status === 422) {
                var errors = xhr.responseJSON ? xhr.responseJSON.errors : null;
                if (errors) {
                    var firstField = null;
                    $.each(errors, function (field, messages) {
                        var message = Array.isArray(messages) ? messages[0] : messages;
                        var $input = $form.find("#" + field);
                        if (!$input.length) {
                            $input = $form.find('[name="' + field + '"]');
                        }
                        if (!$input.length) {
                            $input = $form.find('[name="' + field + '[]"]');
                        }

                        if ($input.length) {
                            $input.addClass("is-invalid");
                            var $choicesWrapper = $input.closest(".choices");
                            if ($choicesWrapper.length) {
                                $choicesWrapper.addClass("is-invalid");
                            }
                            $input.siblings(".invalid-feedback").remove();
                            $input.after('<div class="invalid-feedback d-block text-start">' + message + '</div>');

                            if (!firstField) {
                                firstField = $input;
                            }
                        }
                    });

                    if (firstField && firstField.length) {
                        firstField.focus();
                    }
                }
            } else {
                var errorMsg = (xhr.responseJSON && xhr.responseJSON.message) ? xhr.responseJSON.message : "Ocurrió un error al guardar el socio.";
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: errorMsg
                });
            }
        }
    });
});

$(document).on("input change", "#formSocio .is-invalid", function () {
    if (typeof Swal !== "undefined" && Swal.isVisible && Swal.isVisible()) {
        Swal.close();
    }
    $(this).removeClass("is-invalid");
    $(this).closest(".choices").removeClass("is-invalid");
    $(this).siblings(".invalid-feedback").remove();
});
$(document).on('click','.borraImagen',function(){
    Swal.fire({
        title: "¿Estás seguro de borrar la imagen?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        denyButtonText: 'No eliminar'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            var id = this.id.substr(7,20);
            $.ajax({
                url: "socios/deleteImage/"+id,
                type: "GET",
                dataType: "json",
                success: function(data){
                    console.log(data);
                    $("#contenedor-avatar").empty();
                    $("#contenedor-avatar").append("<img src='storage/avatar/noavatar.jpg' class='d-block' width='300px'><div class='mb-3'><input name='avatar' type='file' class='form-control' id='formFile'></div>");
                }
            }); 
        } else if (result.isDenied) {
          Swal.fire("La imagen no se eliminó", "", "info");
        }
      });
});
$(document).on("change","#fichaSocio #avatar_file",function(event){
    var tmppath = URL.createObjectURL(event.target.files[0]);
    $("#contenedor-avatar img").fadeIn("fast").attr('src',tmppath);
});
$(document).on("change","#seleccion-avatar",function(event){
    var tmppath = URL.createObjectURL(event.target.files[0]);
    $("#contenedor-avatar img").fadeIn("fast").attr('src',tmppath);
});
$(document).on("change","#camara-avatar",function(event){
    var tmppath = URL.createObjectURL(event.target.files[0]);
    $("#contenedor-avatar img").fadeIn("fast").attr('src',tmppath);
});

//HERRAMIENTAS CARDS
$(document).on('click','.nuevo-recibo',function(){
    $(".modal-content").css('background-color',"#E9F9E6");
    //Vaciamos campos
    $(".campoRecibo").val("");
    $(".campo_muestra").html("");
    $("#fichaReciboLabel").html("Creación de nuevo recibo<i class='bi bi-bootstrap-reboot ms-3 change-b'></i>");
    //Rellenamos campos
    var numero_socio = this.id.substr(13,20);
    $("#receptor").val(numero_socio).change();
    //$("#fpago").val("efectivo").change();
    $("#iva").val("21").change();
    $("#fecha_emision").val(new Date().toISOString().substr(0,10)).change();
    //Formateamos formulario
    $("#btnDeleteRecibo").css("display","none");
    $("#formRecibo").attr('action',"recibos");
    $("#_method").val("POST");
    //Rellenamos concepto e importe
    var concepto = "";
    $.ajax({
        url: "socios/aux/"+numero_socio,
        type: "GET",
        dataType: "json",
        success: function(data){
            window.socioReciboActual = data;
            $("#items-recibo").empty();
            $("#items-recibo").append(`
                <div class="cabecera-items" style='position:sticky; top:0; background-color:#fff'> 
                    <div class="cabecera-item-recibo-item">
                        <p class='m-auto text-center mb-1 fw-bolder'>Item#</p>
                    </div>
                    <div class="cabecera-item-recibo-nombre"'>
                        <p class='m-auto text-center mb-1 fw-bolder'>Nombre</p>
                    </div>
                    <div class="cabecera-item-recibo-iva">
                        <p class='m-auto text-center mb-1 fw-bolder'>Iva</p>
                    </div>
                    <div class="cabecera-item-recibo-cantidad">
                        <p class='m-auto text-center mb-1 fw-bolder'>Cant</p>
                    </div>
                    <div class="cabecera-item-recibo-pvp">
                        <p class='m-auto text-center mb-1 fw-bolder'>PVP</p>
                    </div>
                    <div class="cabecera-item-recibo-descuento">
                        <p class='m-auto text-center mb-1 fw-bolder'>Descuento %</p>
                    </div>
                    <div class="cabecera-item-recibo-descuento">
                        <p class='m-auto text-center mb-1 fw-bolder'>Descuento €</p>
                    </div>
                    <div class="cabecera-item-recibo-importe">
                        <p class='m-auto text-center mb-1 fw-bolder'>Importe</p>
                    </div>
                    <div class="cabecera-item-recibo-hasta">
                        <p class='m-auto text-center mb-1 fw-bolder'><i class="bi bi-calendar-event me-1"></i>Hasta</p>
                    </div>
                    <div class="cabecera-item-recibo-borrar"></div>
                </div>
            `);
            $.each(data['assigned_actividades'],function(index,value){
                if(value['activa'] == 1){
                    var duracion = parseInt(value['duracion_meses'], 10) || 1;
                    var mesCompleto = (value['mes_completo'] !== undefined) ? value['mes_completo'] : 1;
                    var rango = window.calcularRangoActividad(duracion, mesCompleto, value['fecha_hasta']);
                    var fecha_desde = rango.desde;
                    var fecha_hasta = rango.hasta;

                    $("#items-recibo").append(`
                        <div class="registro-items" style='position:sticky; top:0; background-color:#fff'> 
                            <div class="registro-item-recibo-item">
                                <input type="text" name="input_item_id[]" class='form-control m-auto text-center mb-1 input-item-id empresa-${value['empresa_id']}' readonly value="Actividad-${value['id']}">
                            </div>
                            <div class="registro-item-recibo-nombre">
                                <input name="input_item_nombre[]" class='form-control m-auto text-center mb-1 input-item-nombre empresa-${value['empresa_id']}' value="${value['nombre']}">
                            </div>
                            <div class="registro-item-recibo-iva">
                                <input name="input_item_iva[]" class='form-control m-auto text-center mb-1 input-item-iva empresa-${value['empresa_id']}' readonly value='21'>
                            </div>
                            <div class="registro-item-recibo-cantidad">
                                <input name="input_item_cantidad[]" class="form-control m-auto text-center input-item-cantidad empresa-${value['empresa_id']}" type='number' step='1.00' value='1'>
                            </div>
                            <div class="registro-item-recibo-pvp">
                                <input name="input_item_pvp[]" class="form-control m-auto text-center input-item-pvp empresa-${value['empresa_id']}" type='number' step='0.01' value='${value['precio']}'>
                            </div>
                            <div class="registro-item-recibo-descuento">
                                <input name="input_item_descuento[]" class="form-control m-auto text-center input-item-descuento empresa-${value['empresa_id']}" type='number' step='0.01' value='0'>
                            </div>
                            <div class="registro-item-recibo-descuento">
                                <input class="form-control m-auto text-center input-item-descuento-euro empresa-${value['empresa_id']}" type='number' step='0.01' value='0'>
                            </div>
                            <div class="registro-item-recibo-importe">
                                <input type="number" name="input_item_importe[]" step="0.01" class='form-control m-auto text-center input-item-importe mb-1 empresa-${value['empresa_id']}' value='${value['precio']}'>
                            </div>
                            <div class="registro-item-recibo-hasta">
                                <input type="date" name="input_item_hasta[]" required class='form-control m-auto text-center input-item-hasta mb-1 empresa-${value['empresa_id']}' value='${fecha_hasta}'>
                                <input type="hidden" class="input-item-desde" value="${fecha_desde}">
                            </div>
                            <div class="registro-item-recibo-borrar">
                                <a title='Borrar' class='borrar-item empresa-${value['empresa_id']}' href='#'><i class="bi bi-trash3-fill"></i></a>
                            </div>
                        </div>
                    `); 
                }
            });
            rellenaEmisor();
        }
    });
});
var CURRENT_HISTORIAL_SOCIO = null;
var CURRENT_HISTORIAL_RECIBOS = [];
var CURRENT_HISTORIAL_TIPO = "oficial"; // "oficial" o "b" (control interno)

function isReciboB(r) {
    if (!r) return false;
    if (r.concepto === "Factura TKD") return false;
    var empresaId = parseInt(r.empresa_id, 10);
    if (!isNaN(empresaId) && empresaId === 0) return true;
    if (r.serial && typeof r.serial === "string" && r.serial.length >= 6 && r.serial.substr(4, 2) === "00") {
        return true;
    }
    return false;
}

function renderHistorialRecibosFiltrados() {
    var container = $("#recibos-lista");
    var emptyDiv = $("#historial-recibos-empty");
    var selectedYear = $("#filtroAnoRecibos").val() || "all";
    var term = ($("#buscadorHistorialRecibos").val() || "").toLowerCase().trim();

    var recibos = CURRENT_HISTORIAL_RECIBOS.slice();

    // 1. Filtrar por tipo (Oficiales vs Control Interno)
    if (CURRENT_HISTORIAL_TIPO === "b") {
        recibos = recibos.filter(function(r) {
            return isReciboB(r);
        });
        $("#btnDescargarPdfLote").addClass("d-none");
    } else {
        recibos = recibos.filter(function(r) {
            return !isReciboB(r);
        });
        $("#btnDescargarPdfLote").removeClass("d-none");
    }

    // 2. Filtrar por año
    if (selectedYear !== "all") {
        recibos = recibos.filter(function(r) {
            var fecha = r.fecha_emision || "";
            return fecha.startsWith(selectedYear);
        });
    }

    // 3. Filtrar por texto de búsqueda
    if (term) {
        recibos = recibos.filter(function(r) {
            var serial = (r.serial || "").toString().toLowerCase();
            var concepto = (r.concepto || "").toString().toLowerCase();
            var fpago = (r.fpago || "").toString().toLowerCase();
            var fecha = (r.fecha_emision || "").toString().toLowerCase();
            return serial.includes(term) || concepto.includes(term) || fpago.includes(term) || fecha.includes(term);
        });
    }

    // Calcular métricas
    var totalImporte = 0;
    recibos.forEach(function(r) {
        var imp = parseFloat(r.importe) || 0;
        totalImporte += imp;
    });

    $("#metricRecibosCount").text(recibos.length);
    $("#metricRecibosTotal").text(totalImporte.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €");

    // Actualizar botón de descarga en lote (solo para oficiales)
    if (CURRENT_HISTORIAL_SOCIO && CURRENT_HISTORIAL_TIPO !== "b") {
        var urlLote = "/socios/" + CURRENT_HISTORIAL_SOCIO.id + "/recibos/pdf-anual?year=" + selectedYear;
        $("#btnDescargarPdfLote").attr("href", urlLote);
        if (selectedYear === "all") {
            $("#btnDescargarPdfLoteTexto").text("Descargar todos (PDF)");
        } else {
            $("#btnDescargarPdfLoteTexto").text("Descargar " + selectedYear + " (PDF)");
        }
    }

    // Si no hay resultados
    if (recibos.length === 0) {
        container.empty();
        if (CURRENT_HISTORIAL_TIPO === "b") {
            emptyDiv.find("h6").text("Sin comprobantes internos");
            emptyDiv.find("p").text("No se encontraron comprobantes de régimen interno para este socio en el período seleccionado.");
        } else {
            emptyDiv.find("h6").text("Sin recibos registrados");
            emptyDiv.find("p").text("No se encontraron recibos oficiales emitidos para este socio con los filtros seleccionados.");
        }
        emptyDiv.removeClass("d-none");
        return;
    }

    emptyDiv.addClass("d-none");
    container.empty();

    var html = "";
    recibos.forEach(function(r) {
        var isTKD = (r.concepto === "Factura TKD");
        var isB = isReciboB(r);
        var reciboId = r.id || ("tkd_" + r.serial);
        var importeText = isTKD ? "Pagado" : (parseFloat(r.importe || 0).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €");
        var ivaBadge = (!isTKD && r.iva) ? '<span class="badge bg-secondary-subtle text-secondary small ms-1">(' + r.iva + '% IVA)</span>' : '';

        // Badge para forma de pago
        var fpago = r.fpago || (isTKD ? "Tarjeta/Bizum" : "Efectivo");
        var fpagoLower = fpago.toLowerCase();
        var badgeFpagoClass = "bg-secondary-subtle text-secondary";
        if (fpagoLower.includes("tarjeta") || fpagoLower.includes("card")) {
            badgeFpagoClass = "bg-primary-subtle text-primary border border-primary-subtle";
        } else if (fpagoLower.includes("efectivo")) {
            badgeFpagoClass = "bg-success-subtle text-success border border-success-subtle";
        } else if (fpagoLower.includes("bizum")) {
            badgeFpagoClass = "bg-info-subtle text-info border border-info-subtle";
        } else if (fpagoLower.includes("domiciliac") || fpagoLower.includes("banco")) {
            badgeFpagoClass = "bg-warning-subtle text-warning-emphasis border border-warning-subtle";
        } else if (fpagoLower.includes("stripe")) {
            badgeFpagoClass = "bg-purple-subtle text-purple border border-purple-subtle";
        }

        // Acciones y badges según procedencia
        var btnVer = "";
        var btnEmail = "";
        var btnFacturar = "";
        var origenBadge = "";
        var serialBadge = "";

        if (isTKD) {
            btnVer = '<a target="_blank" href="/recibos/facturatkd/' + r.serial + '" class="btn btn-outline-danger btn-sm" title="Ver / Descargar Factura TKD"><i class="bi bi-file-earmark-pdf"></i></a>';
            origenBadge = '<span class="badge bg-light text-dark border small"><i class="bi bi-award me-1 text-danger"></i>TKD</span>';
            serialBadge = '<span class="badge bg-dark fw-bold">#' + r.serial + '</span>';
        } else if (isB) {
            btnVer = '<a target="_blank" href="/recibos/imprimir/' + r.id + '" class="btn btn-outline-secondary btn-sm" title="Ver / Descargar Comprobante"><i class="bi bi-file-earmark-pdf"></i></a>';
            btnEmail = '';
            btnFacturar = '<span class="d-inline-block" tabindex="0" title="No facturable: Comprobante de régimen interno"><button class="btn btn-outline-secondary btn-sm opacity-50" type="button" disabled style="cursor: not-allowed;"><i class="bi bi-file-earmark-x"></i></button></span>';
            origenBadge = '<span class="badge bg-secondary-subtle text-secondary border small"><i class="bi bi-shield me-1"></i>Interno</span>';
            serialBadge = '<span class="badge bg-secondary fw-bold text-white">#' + r.serial + '</span>';
        } else {
            btnVer = '<a target="_blank" href="/recibos/imprimir/' + r.id + '" class="btn btn-outline-secondary btn-sm" title="Ver / Descargar Recibo PDF"><i class="bi bi-file-earmark-pdf"></i></a>';
            btnEmail = '<a href="/recibos/enviar/' + r.id + '" class="btn btn-outline-primary btn-sm btn-loader" title="Enviar recibo por email al socio"><i class="bi bi-envelope"></i></a>';
            btnFacturar = '<a href="/recibos/' + r.id + '/facturar" class="btn btn-outline-info btn-sm" title="Convertir a Factura Oficial"><i class="bi bi-file-earmark-medical"></i></a>';
            var empNombre = (r.empresa && r.empresa.nombre) ? r.empresa.nombre : 'Empresa Oficial';
            origenBadge = '<span class="badge bg-light text-secondary border small" title="' + empNombre + '"><i class="bi bi-building me-1"></i>' + empNombre + '</span>';
            serialBadge = '<span class="badge bg-dark fw-bold">#' + r.serial + '</span>';
        }

        // Tabla de líneas
        var tablaLineasHtml = "";
        if (r.lineas && r.lineas.length > 0) {
            var filasLineas = "";
            r.lineas.forEach(function(l, idx) {
                var pvpFormatted = (parseFloat(l.pvp) || 0).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
                var impFormatted = (parseFloat(l.importe) || 0).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
                var fechaHasta = l.fecha_hasta ? ('<i class="bi bi-calendar-check me-1 text-success"></i>' + l.fecha_hasta) : '-';

                filasLineas += '<tr>' +
                    '<td class="text-center text-muted small">' + (idx + 1) + '</td>' +
                    '<td class="fw-semibold text-dark">' + (l.concepto || l.descripcion || ('Item #' + l.item_id)) + '</td>' +
                    '<td class="text-end">' + pvpFormatted + '</td>' +
                    '<td class="text-center">' + (l.cantidad || 1) + '</td>' +
                    '<td class="text-center">' + (l.iva || 0) + '%</td>' +
                    '<td class="text-center">' + (l.descuento ? (l.descuento + '%') : '-') + '</td>' +
                    '<td class="text-end fw-bold text-dark">' + impFormatted + '</td>' +
                    '<td class="text-center small text-secondary">' + fechaHasta + '</td>' +
                '</tr>';
            });

            tablaLineasHtml = '<div class="table-responsive bg-white rounded border">' +
                '<table class="table table-sm table-hover mb-0 align-middle" style="font-size: 0.85rem;">' +
                    '<thead class="table-light">' +
                        '<tr>' +
                            '<th class="text-center" style="width: 40px;">#</th>' +
                            '<th>Concepto / Actividad</th>' +
                            '<th class="text-end">PVP</th>' +
                            '<th class="text-center">Cant.</th>' +
                            '<th class="text-center">IVA</th>' +
                            '<th class="text-center">Dto.</th>' +
                            '<th class="text-end">Subtotal</th>' +
                            '<th class="text-center">Vigencia hasta</th>' +
                        '</tr>' +
                    '</thead>' +
                    '<tbody>' + filasLineas + '</tbody>' +
                '</table>' +
            '</div>';
        } else {
            tablaLineasHtml = '<div class="text-muted small py-2 px-1"><i class="bi bi-info-circle me-1"></i>Sin desglose de líneas detalladas registrado para este recibo.</div>';
        }

        html += '<div class="card border shadow-sm rounded-3 recibo-card bg-white ' + (isB ? 'border-secondary-subtle' : '') + '" id="card-recibo-' + reciboId + '">' +
            '<div class="card-header bg-white py-2 px-3 d-flex align-items-center justify-content-between flex-wrap gap-2 border-0">' +
                '<div class="d-flex align-items-center gap-2 flex-wrap">' +
                    '<button type="button" class="btn btn-sm btn-light border py-1 px-2 toggle-recibo-lineas shadow-none" data-id="' + reciboId + '" title="Desplegar líneas">' +
                        '<i class="bi bi-chevron-down toggle-icon-' + reciboId + '"></i>' +
                    '</button>' +
                    serialBadge +
                    origenBadge +
                    '<span class="text-secondary small"><i class="bi bi-calendar-event me-1"></i>' + (r.fecha_emision || '-') + '</span>' +
                    '<strong class="text-dark">' + (r.concepto || 'Sin concepto') + '</strong>' +
                    '<span class="badge ' + badgeFpagoClass + '">' + fpago + '</span>' +
                '</div>' +
                '<div class="d-flex align-items-center gap-3">' +
                    '<div class="text-end">' +
                        '<span class="fs-6 fw-bold text-dark">' + importeText + '</span>' +
                        ivaBadge +
                    '</div>' +
                    '<div class="btn-group btn-group-sm shadow-none">' +
                        btnVer +
                        btnEmail +
                        btnFacturar +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="recibo-lineas-container d-none p-3 pt-0 border-top bg-light" id="lineas-recibo-' + reciboId + '">' +
                '<div class="mt-2">' + tablaLineasHtml + '</div>' +
            '</div>' +
        '</div>';
    });

    container.html(html);
}

$(document).on('click', '.historial-recibos', function(e) {
    e.preventDefault();
    var id = $(this).attr('id').replace('historial-recibos-', '');

    // Reset de estado visual a vista oficial
    CURRENT_HISTORIAL_TIPO = "oficial";
    $("#historialRecibosHeader").css("background-color", "#483948");
    $("#badgeModoHistorial").addClass("d-none");
    $("#btnDescargarPdfLote").removeClass("d-none");

    $("#historial-recibos-loading").removeClass("d-none");
    $("#historial-recibos-empty").addClass("d-none");
    $("#recibos-lista").empty();
    $("#historialRecibosSubtitulo").text("Cargando recibos del socio...");
    $("#filtroAnoRecibos").empty().append('<option value="all">Todos los años</option>');
    $("#buscadorHistorialRecibos").val('');
    $("#metricRecibosCount").text('0');
    $("#metricRecibosTotal").text('0,00 €');

    $.ajax({
        url: "socios/" + id,
        type: "GET",
        dataType: "json",
        success: function(data) {
            $("#historial-recibos-loading").addClass("d-none");
            CURRENT_HISTORIAL_SOCIO = data;

            var recibos = data.recibos || [];
            // Ordenar por fecha_emision descendente
            recibos.sort(function(a, b) {
                return new Date(b.fecha_emision) - new Date(a.fecha_emision);
            });
            CURRENT_HISTORIAL_RECIBOS = recibos;

            // Actualizar encabezados
            $("#historialRecibosLabel").html('Historial de Recibos');
            $("#historialRecibosSubtitulo").html(
                '<strong class="text-white">' + data.nombre + ' ' + data.apellidos + '</strong>' +
                ' <span class="badge bg-light text-dark ms-1">#' + (data.numero_socio || '-') + '</span>'
            );

            // Extraer años disponibles
            var anosSet = {};
            recibos.forEach(function(r) {
                if (r.fecha_emision && r.fecha_emision.length >= 4) {
                    var y = r.fecha_emision.substr(0, 4);
                    anosSet[y] = true;
                }
            });

            var anos = Object.keys(anosSet).sort().reverse();
            var selectAno = $("#filtroAnoRecibos");
            selectAno.empty();
            selectAno.append('<option value="all">Todos los años</option>');

            var anoActual = new Date().getFullYear().toString();
            var anoDefecto = "all";

            anos.forEach(function(ano) {
                var selected = (ano === anoActual) ? ' selected' : '';
                if (ano === anoActual) {
                    anoDefecto = anoActual;
                }
                selectAno.append('<option value="' + ano + '"' + selected + '>' + ano + '</option>');
            });

            if (anoDefecto !== "all") {
                selectAno.val(anoDefecto);
            }

            renderHistorialRecibosFiltrados();
        },
        error: function(xhr) {
            $("#historial-recibos-loading").addClass("d-none");
            Swal.fire("Error", "No se pudo cargar el historial de recibos del socio.", "error");
        }
    });
});

$(document).on('click', '.change-historial-interno', function(e) {
    e.preventDefault();
    if (CURRENT_HISTORIAL_TIPO === "oficial") {
        CURRENT_HISTORIAL_TIPO = "b";
        $("#historialRecibosHeader").css("background-color", "#343a40");
        $("#badgeModoHistorial").removeClass("d-none");
        $("#btnDescargarPdfLote").addClass("d-none");
    } else {
        CURRENT_HISTORIAL_TIPO = "oficial";
        $("#historialRecibosHeader").css("background-color", "#483948");
        $("#badgeModoHistorial").addClass("d-none");
        $("#btnDescargarPdfLote").removeClass("d-none");
    }

    renderHistorialRecibosFiltrados();
});

// Eventos de filtrado en el modal
$(document).on('change', '#filtroAnoRecibos', function() {
    renderHistorialRecibosFiltrados();
});

$(document).on('keyup input', '#buscadorHistorialRecibos', function() {
    renderHistorialRecibosFiltrados();
});

// Toggle de detalle de líneas por recibo
$(document).on('click', '.toggle-recibo-lineas', function(e) {
    e.preventDefault();
    var reciboId = $(this).data('id');
    var container = $("#lineas-recibo-" + reciboId);
    var icon = $(".toggle-icon-" + reciboId);

    container.toggleClass('d-none');
    if (container.hasClass('d-none')) {
        icon.removeClass('bi-chevron-up').addClass('bi-chevron-down');
    } else {
        icon.removeClass('bi-chevron-down').addClass('bi-chevron-up');
    }
});
$(document).on('click','.activar-socio',function(){
    $("#fechahasta").modal("show");
    var id    = this.id.substr(14,20);
    $("#fechahastaForm").attr('action',"socios/changestatus/"+id);
    $("#accion").val("activar");
});
$(document).on('click','.desactivar-socio',function(){
    var id = this.id.substr(17,20);
    Swal.fire({
        title: "¿Estás seguro que deseas desactivar a este socio?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Desactivar",
        denyButtonText: 'No desactivar'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            $("#form-desactivar-socio-"+id).submit();
        } else if (result.isDenied) {
          Swal.fire("El socio no se desactivó", "", "info");
        }
      });
});
$(document).on('click','.desplegable',function(){
    var icon = $(this);
    $.each(icon.attr('class').split(' '),function(index,value){
        console.log(value);
        if(value == 'bi-caret-down-fill'){
            $(".registro-historial-items-"+icon.parent().parent().parent().parent().attr('id').substr(18,100)).removeClass('d-none');
            icon.addClass('bi-caret-up-fill');
            icon.removeClass('bi-caret-down-fill');
        }
        if(value == 'bi-caret-up-fill'){
            $(".registro-historial-items-"+icon.parent().parent().parent().parent().attr('id').substr(18,100)).addClass('d-none');
            icon.addClass('bi-caret-down-fill');
            icon.removeClass('bi-caret-up-fill');
        }
    });
});
$(document).on('mouseover',"#socios-container .card-body",function(){
    $(this).parent().find(".card-img-top").removeClass('grey-filter');
});
$(document).on('mouseout',"#socios-container .card-body",function(){
    $(this).parent().find(".card-img-top").addClass('grey-filter');
});
$(document).on('click','.change-b',function(){
    if($(this).parent().parent().parent().css('background-color') == "rgb(249, 230, 233)"){
        $(this).parent().parent().parent().css('background-color',"#E9F9E6");
        $.ajax({
            url: "recibos/lastSerial/"+$("#emisor").val(),
            type: "GET",
            dataType: "json",
            success: function(data){
                $("#serial_recibo").html(data);
                $("#serial_recibo").css('color',"blue");
                $("#serial_recibo").css('font-weight',"bolder");
                $("#b").remove();
            }
        });
    }else if($(this).parent().parent().parent().css('background-color') == "rgb(233, 249, 230)"){
        $(this).parent().parent().parent().css('background-color',"#F9E6E9");
        $.ajax({
            url: "recibos/lastSerial/99",
            type: "GET",
            dataType: "json",
            success: function(data){
                console.log(data);
                $("#serial_recibo").html(data);
                $("#serial_recibo").css('color',"red");
                $("#serial_recibo").css('font-weight',"bolder");
                $("#formRecibo").append("<input id='b' class='d-none' name='b' type='checkbox' checked>");
            }
        });
    }
    
});
$(document).on('click','.btnDeleteSocio',function(){
    Swal.fire({
        title: "¿Estás seguro que deseas eliminar a este socio?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        denyButtonText: 'No eliminar'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            $("#form"+this.id).submit();
        } else if (result.isDenied) {
          Swal.fire("El socio no se eliminó", "", "info");
        }
      });
});
$(document).on('click','.ver-socio-pendiente',function(){
    $("#fichaSocio").modal("show");
    var id = this.id.substr(16,25);
    $("#_method").val("PUT");
    $("#formSocio").attr('action',"socios/"+id);
    $(".btnDeleteSocio").css("display","block");
    $("#avatar").attr('src',"storage/avatar/noavatar.jpg");
    $("#actividades").empty();
    $("#usuarios").empty();
    $("#formSocio .is-invalid").removeClass("is-invalid");
    $("#formSocio .invalid-feedback").remove();
    $(".campo").val("");
    $(".campoSocio").val("");
    $("#formSocio .modal-footer").empty();
    $("#formSocio .modal-footer").append(`
        <div class="d-flex" style="width:30%">
            <a href="#" onclick="" id="delete-`+id+`" class="btn btn-danger ms-2 me-2 btnDeleteSocio" style="display: block;">Eliminar</a>
        </div>
        <div class="d-flex" style="width:35%">
            <a href="#" class="btn btn-secondary m-1 cambio-avatar" id="cambio-avatar-`+id+`" title="Notificar cambio de avatar">Notificar cambio de avatar<i class="ms-1 bi bi-send-exclamation-fill"></i></a>
            <a href="#" class="btn btn-secondary m-1 aprobar-socio" id="aprobar-socio-`+id+`" title="Aprobar socio">Aprobar socio<i class="ms-1 bi bi-cloud-upload-fill"></i></a>
        </div>
        <div class="d-flex flex-row-reverse" style="width:30%">
            <button type="button" class="btn btn-secondary ms-2 me-2" data-bs-dismiss="modal">Cerrar</button>
            <button type="submit" class="btn btn-primary boton">Guardar</button>
        </div>
    `);

    $.ajax({
        url: "socios/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#fichaSocioLabel").html("Aprobar socio "+data['nombre']+" "+data['apellidos']);
            $.each(data,function(index,value){
                if(index == 'avatar'){
                    $("#contenedor-avatar").empty();
                    if(value === null){
                        $("#contenedor-avatar").append("<img src='storage/avatar/noavatar.jpg' class='d-block' width='300px'>");
                    }else{
                        $("#contenedor-avatar").append("<img id='image-"+data['id']+"' src='storage"+value+"' class='d-block' width='300px'><button  class='borraImagen' id='imgdel-"+data['id']+"' type='button'><i class='bi bi-trash3'></i></button>");
                    }
                   $("#contenedor-avatar").append("<input type='file' accept='.jpg,.png,.jpeg' class='campo form-control' name='avatar_file' id='avatar_file' style='text-align:center'>"); 
                }
                if(index == "actividades" && value!= null){
                    var choicesMulti = Array();
                    var valorselect = Array();
                    $("#actividades").append("<label>Actividad/es</label><select multiple class='campo form-control' name='actividades[]' value='' id='actividades-list' style='text-align:center'></select>");
                    $.each(value,function(index2,value2){
                        var selected = false;
                        if(value2['activa']){
                            $.each(data['assigned_actividades'],function(index3,value3){
                                valorselect.push(value3['id']);
                                if(value2['id'] == value3['id']){
                                    selected = true;
                                }
                            });
                            choicesMulti.push({
                                value:value2['id'],
                                label:value2['nombre'],
                                selected:selected,
                            });
                        }
                    });
                    var selectClases = new Choices('#actividades-list', {
                        choices: choicesMulti,
                        removeItemButton: true,
                        maxItemCount: -1,
                        searchResultLimit: -1,
                        renderChoiceLimit: -1,
                        allowHTML: false,
                        searchEnabled: true,
                        searchChoices: true,
                        searchFloor: 1,
                        searchFields: ['label', 'value'],
                        noResultsText: 'Sin resultados',
                        noChoicesText: 'Sin resultados',
                        placeholderValue: 'Selecciona...',
                        itemSelectText: "",
                    }); 
                    $("#actividades").val(valorselect);
                }else{
                    $("#"+index.toLowerCase()).val(value);
                }
            });
            renderUsuariosSelect(data['todos_usuarios'], data['users'], data['user']);
        }
    }); 
});
$(document).on('click','.aprobar-socio',function(){
    Swal.fire({
        title: "¿Estás seguro que deseas incorporar a este socio a la base de datos?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Si, incorporar",
        denyButtonText: 'No incorporar'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            var id = this.id.substr(14,25);
            $.ajax({
                url: "socios/aprobarsocio/"+id,
                type: "GET",
                dataType: "json",
                success: function(data){
                    if(data == true){
                        location.reload();
                    }
                }
            });
        } else if (result.isDenied) {
          Swal.fire("El socio no se incorporó a la base de datos", "", "info");
        }
      });
});
$(document).on('click','.cambio-avatar',function(){
    Swal.fire({
        title: "¿Estás seguro que deseas enviar un email a este socio para que cambie su avatar?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Si, enviar",
        denyButtonText: 'No enviar'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            var id = this.id.substr(14,25);
            $.ajax({
                url: "socios/notificacion/"+id,
                type: "GET",
                dataType: "json",
                data: {asunto:"Cambio de avatar",mensaje:"Por favor, cambia tu avatar para poder ser aprobado como socio.<br><a style='color:#ffffff' href='https://fitnessfabra.basicsoftgym.es' target='_blank'>Accede a tu perfil</a>"},
                success: function(data){
                    if(data == true){
                        Swal.fire("Email enviado", "", "success");
                    }else{
                        Swal.fire("El email no se pudo enviar", "", "error");
                    }
                }
            });
        } else if (result.isDenied) {
          
        }
      });
});
//Validacion DNI/NIE
$(document).on('change',"#dni",function(){
    if($("#tipo_documento").val() == "DNI"){
        $("#dni").attr('pattern','[0-9]{8}[A-Z]{1}');
    }else if($("#tipo_documento").val() == "NIE"){
        $("#dni").attr('pattern','[XYZ]{1}[0-9]{7}[A-Z]{1}');
    }else{
        $("#dni").attr('pattern',null);
    }
});
$(document).on('change',"#tipo_documento",function(){
    if($("#tipo_documento").val() == "DNI"){
        $("#dni").attr('pattern','[0-9]{8}[A-Z]{1}');
    }else if($("#tipo_documento").val() == "NIE"){
        $("#dni").attr('pattern','[XYZ]{1}[0-9]{7}[A-Z]{1}');
    }else{
        $("#dni").attr('pattern',null);
    }
});
//FUNCIONES
function recalculoimporte(){
    var lineas = $('.registro-items');
    var importe_total = 0.00;
    $.each(lineas,function(){
        if($(this).find('.input-item-importe').prop('disabled') == false){
            importe_total = importe_total + parseFloat($(this).find('.input-item-importe').val());
        }
    });
    $("#importe").val(importe_total).change();
}
function construccionconcepto(){
    var lineas   = $('.registro-items');
    var concepto = "";
    var meses    = ['ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'];
    var fecha    = new Date();
    $.each(lineas,function(index,value){
        if($(this).find('.input-item-id').prop('disabled') == false){
            if($(this).find('.input-item-id').val().split("-")[0] == "Actividad"){
                if($(this).find('.input-item-desde').val().substr(8,2) == "01"){
                    concepto += " // Cuota "+meses[$(this).find('.input-item-hasta').val().substr(5,2) - 1]+" "+$(this).find('.input-item-nombre').val();                    
                }else{
                    concepto += " // Cuota "+$(this).find('.input-item-nombre').val()+ " desde "+ $(this).find('.input-item-desde').val().substr(8,2)+"-"+$(this).find('.input-item-desde').val().substr(5,2)+"-"+$(this).find('.input-item-desde').val().substr(0,4) +" hasta "+$(this).find('.input-item-hasta').val().substr(8,2)+"-"+$(this).find('.input-item-hasta').val().substr(5,2)+"-"+$(this).find('.input-item-hasta').val().substr(0,4);
                }
            }else{
                concepto +=  " // "+$(this).find('.input-item-nombre').val();
            }
        }
    });
    $("#concepto").val(concepto).change();
}
function rellenaEmisor(){
    var optionsEmisor;
    $.ajax({
        url: "empresas/aux",
        type: "GET",
        dataType: "json",
        success: function(data){
            $(".registro-items input").attr('disabled',true);
            $.each(data,function(index,value){
                if($(".empresa-"+value['id']).length > 0){
                    optionsEmisor += "<option selected value='"+value['id']+"'>"+value['nombre']+"</option>";
                    $("#emisor-nombre").html(value['nombre']);
                    $("#emisor-cif").html(value['cif']);
                    $("#emisor-direccion").html(value['direccion']);
                    $("#emisor-cpostal").html(value['cpostal']);
                    $("#emisor-poblacion").html(value['poblacion']);
                    $("#emisor-telefono").html(value['telefono']);
                    $("#emisor-web").html(value['web']);
                    $("#logo-recibo img").attr('src',"storage/"+value['logo']);
                }else{
                    optionsEmisor += "<option value='"+value['id']+"'>"+value['nombre']+"</option>";
                }
            });
            $("#emisor").empty();
            $("#emisor").append(optionsEmisor);
            $(".empresa-"+$("#emisor").val()).attr('disabled',false);
            $.ajax({
                url: "recibos/lastSerial/"+$("#emisor").val(),
                type: "GET",
                dataType: "json",
                success: function(data){
                    $("#serial_recibo").html(data);
                    $("#serial_recibo").css('color',"blue");
                    $("#serial_recibo").css('font-weight',"bolder");
                }
            });
            recalculoimporte();
            construccionconcepto();
        }
    });
}
function rellenaReceptor(numSoc){
    $.ajax({
        url: "socios/aux/"+numSoc,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#receptor-numsoc").html(data['numero_socio']);
            $("#receptor-socio").html(data['nombre']+ " "+data['apellidos']);
            $("#receptor-nif").html(data['dni']);
            $("#receptor-direccion").html(data['direccion']);
            $("#receptor-cpostal").html(data['cpostal']);
            $("#receptor-poblacion").html(data['poblacion']);
            $("#socio_id").val(data['id']);
            $("#receptor").val(numSoc);
        }
    });
}
function rellenaConceptoActividad(){
    var concepto = "";
    $.each($(".etiquetas"),function(index,value){
        if(index == 0){
            concepto = "Cuota " + $($(value).children("p")).html();
        }else{
            if($($(value).children("p")).html() != "Añadir producto"){
                concepto += "+ Cuota " + $($(value).children("p")).html(); 
            }
        }
    });
    $("#concepto").val(concepto).change();
}
function pad (str, max) {
    str = str.toString();
    return str.length < max ? pad("0" + str, max) : str;
}
var ELEMENTOS_CARGADOS = 0;
// La carga progresiva por scroll y la ordenación de columnas ahora son gestionadas reactivamente por Livewire (SocioList).

// Control de Sincronización Resiliente y Diagnóstico con el Torno ZKBio
function renderModalTornoList(socios) {
    var container = $("#modal-torno-list");
    var emptyDiv = $("#modal-torno-empty");
    var badgeCount = $("#modal-torno-badge-count");
    var topbarCount = $("#torno-pending-count");
    var wrapper = $("#torno-sync-wrapper");

    var count = socios ? socios.length : 0;
    badgeCount.text(count + (count === 1 ? " pendiente" : " pendientes"));
    topbarCount.text(count);

    if (count === 0) {
        container.empty();
        emptyDiv.removeClass("d-none");
        wrapper.addClass("d-none");
        return;
    }

    emptyDiv.addClass("d-none");
    wrapper.removeClass("d-none");

    var html = "";
    socios.forEach(function(s) {
        var estadoBadge = s.status === 1 
            ? '<span class="badge bg-success-subtle text-success border border-success-subtle">Activo (hasta: ' + s.fecha_hasta + ')</span>'
            : '<span class="badge bg-secondary-subtle text-secondary border">Inactivo</span>';

        var fechaError = s.zkbio_sync_error_at 
            ? '<span class="text-muted ms-2" style="font-size: 0.8rem;"><i class="bi bi-clock me-1"></i>' + s.zkbio_sync_error_at + '</span>' 
            : "";

        html += '<div class="card border p-2 shadow-sm rounded-3 socio-torno-card mb-2" id="card-torno-socio-' + s.id + '">' +
            '<div class="d-flex align-items-center justify-content-between flex-wrap gap-2">' +
                '<div class="d-flex align-items-center gap-3">' +
                    '<img src="' + s.avatar + '" alt="Avatar" class="rounded-circle border" style="width: 44px; height: 44px; object-fit: cover;">' +
                    '<div>' +
                        '<div class="d-flex align-items-center gap-2 flex-wrap">' +
                            '<span class="badge bg-dark">#' + (s.numero_socio || '-') + '</span>' +
                            '<strong class="text-dark">' + (s.nombre_completo || 'Sin nombre') + '</strong>' +
                            estadoBadge +
                        '</div>' +
                        '<div class="text-danger small mt-1 d-flex align-items-center flex-wrap">' +
                            '<i class="bi bi-exclamation-triangle-fill me-1 text-warning"></i>' +
                            '<strong>Motivo:&nbsp;</strong>' +
                            '<span class="fw-semibold text-danger">' + (s.zkbio_sync_error || 'Pendiente de enviar al torno') + '</span>' +
                            fechaError +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="d-flex align-items-center gap-2">' +
                    '<button type="button" class="btn btn-sm btn-outline-primary btn-sync-single-torno d-flex align-items-center gap-1" data-id="' + s.id + '" data-nombre="' + (s.nombre_completo || '') + '">' +
                        '<i class="bi bi-arrow-repeat"></i>' +
                        '<span>Reintentar</span>' +
                    '</button>' +
                '</div>' +
            '</div>' +
        '</div>';
    });

    container.html(html);
}

function executeTornoSync(isAuto = false) {
    var btnTopbar = $("#btnSyncTorno");
    var iconTopbar = $("#iconSyncTorno");
    var btnModal = $("#btnSyncTornoModalAll");
    var iconModal = $("#iconSyncTornoModal");

    btnTopbar.prop("disabled", true);
    iconTopbar.addClass("spin-anim");
    btnModal.prop("disabled", true);
    iconModal.addClass("spin-anim");

    $.ajax({
        url: "/socios/zkbio/sync",
        type: "POST",
        data: {
            _token: $('meta[name="csrf-token"]').attr("content"),
            limit: 50
        },
        dataType: "json",
        success: function(resp) {
            btnTopbar.prop("disabled", false);
            iconTopbar.removeClass("spin-anim");
            btnModal.prop("disabled", false);
            iconModal.removeClass("spin-anim");

            if (resp.estado === "success") {
                if (resp.socios) {
                    renderModalTornoList(resp.socios);
                } else {
                    checkTornoPendingStatus(false);
                }

                if (resp.data && resp.data.success > 0) {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: resp.data.failed === 0 ? "success" : "warning",
                        title: isAuto 
                            ? "Accesos sincronizados con el torno (" + resp.data.success + " socios actualizados)"
                            : resp.mensaje,
                        showConfirmButton: false,
                        timer: 3500
                    });
                }
            }
        },
        error: function(xhr) {
            btnTopbar.prop("disabled", false);
            iconTopbar.removeClass("spin-anim");
            btnModal.prop("disabled", false);
            iconModal.removeClass("spin-anim");
            if (!isAuto) {
                Swal.fire("Error de Conexión", "No se pudo comunicar con el torno ZKBio. Asegúrate de que el PC de recepción y el software están encendidos.", "error");
            }
        }
    });
}

function checkTornoPendingStatus(autoSyncIfPending = false) {
    var wrapper = $("#torno-sync-wrapper");
    if (!wrapper.length) return;

    $.ajax({
        url: "/socios/zkbio/status",
        type: "GET",
        dataType: "json",
        success: function(resp) {
            if (resp && resp.pending_count > 0) {
                $("#torno-pending-count").text(resp.pending_count);
                wrapper.removeClass("d-none");
                renderModalTornoList(resp.socios || []);

                // Auto-sincronización instantánea al arrancar la pantalla de mostrador si venía apagado
                if (autoSyncIfPending) {
                    executeTornoSync(true);
                }
            } else {
                wrapper.addClass("d-none");
                renderModalTornoList([]);
            }
        },
        error: function() {
            // Silencioso ante errores de red o sesión
        }
    });
}

// Reintento individual de un socio concreto desde el modal
$(document).on("click", ".btn-sync-single-torno", function(e) {
    e.preventDefault();
    var btn = $(this);
    var socioId = btn.data("id");
    var icon = btn.find("i");

    btn.prop("disabled", true);
    icon.addClass("spin-anim");

    $.ajax({
        url: "/socios/" + socioId + "/zkbio/sync-single",
        type: "POST",
        data: {
            _token: $('meta[name="csrf-token"]').attr("content")
        },
        dataType: "json",
        success: function(resp) {
            btn.prop("disabled", false);
            icon.removeClass("spin-anim");

            if (resp.estado === "success") {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: resp.mensaje,
                    showConfirmButton: false,
                    timer: 3000
                });
                $("#card-torno-socio-" + socioId).slideUp(250, function() {
                    $(this).remove();
                    checkTornoPendingStatus(false);
                });
            } else {
                Swal.fire({
                    icon: "warning",
                    title: "No se pudo sincronizar",
                    text: resp.mensaje || "Error al sincronizar con el torno.",
                    confirmButtonText: "Entendido"
                });
                checkTornoPendingStatus(false);
            }
        },
        error: function(xhr) {
            btn.prop("disabled", false);
            icon.removeClass("spin-anim");
            var err = (xhr.responseJSON && xhr.responseJSON.message) ? xhr.responseJSON.message : "Error al conectar con el servidor.";
            Swal.fire("Error", err, "error");
        }
    });
});

// Sincronizar todos desde el modal
$(document).on("click", "#btnSyncTornoModalAll", function(e) {
    e.preventDefault();
    executeTornoSync(false);
});

// Al abrir el modal, refrescar el diagnóstico en tiempo real
$(document).on("show.bs.modal", "#modalTornoPendientes", function() {
    checkTornoPendingStatus(false);
});

$(document).ready(function() {
    // Asegurar que el modal esté directamente en el body para evitar solapamientos con el backdrop (fade)
    if ($('#modalTornoPendientes').length && !$('#modalTornoPendientes').parent().is('body')) {
        $('#modalTornoPendientes').appendTo('body');
    }
    // Al abrir BSGym en recepción, si hay pendientes se auto-sincronizan en 0 segundos
    checkTornoPendingStatus(true);
});